import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";
import { customToast as toast } from "../utils";

const ApprovalService = {
  get: (approvalType) =>
    axios
      .get(`${endpoints.BASE_URL}${endpoints.GET_APPROVAL}${approvalType}`)
      .then((res) => res.data)
      .catch((err) => {
        toast.error(err.message);
      })
};

export default ApprovalService;
